module.exports = __webpack_public_path__ + "ae265a5557dc7a78f8c052de864034c1.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/projekte/mythos-1.jpg
// module id = 525
// module chunks = 0